import { render, staticRenderFns } from "./employee-history-list-item.component.vue?vue&type=template&id=3d4d96a5&scoped=true&"
import script from "./employee-history-list-item.component.vue?vue&type=script&lang=ts&"
export * from "./employee-history-list-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./employee-history-list-item.component.vue?vue&type=style&index=0&id=3d4d96a5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d96a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
